import axios from 'axios'
import type { LoginMenuDto } from 'modules/auth/api/authService'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? ''

const buildUrl = (path: string) => {
  if (!API_BASE_URL) return path
  return `${API_BASE_URL.replace(/\/$/, '')}${path}`
}

export async function fetchUserMenus(userId: string, tenantId?: string): Promise<LoginMenuDto[]> {
  if (!userId) return []

  const response = await axios.get<LoginMenuDto[]>(buildUrl(`/api/v1/menus/user/${userId}`), {
    params: {
      tenantId,
    },
  })

  return response.data ?? []
}
